import { useVoixToast } from "@voix/composables/useVoixToast";
import { useAdminStore } from "@voix/store/adminStore";
import { useReleasesStore } from "@voix/store/releasesStore";
import { $voixNuxtApi } from "@voix/voix-layer/composables/voixNuxtApi";
function setReleasesInStore(response) {
  if (response) {
    const releasesStore = useReleasesStore();
    releasesStore.setReleases(response.data);
    releasesStore.setPagination(
      response.meta.current_page,
      response.meta.last_page
    );
  }
}
async function getReleases(variables) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  if (variables.orderBy) {
    variables.orderBy = variables.orderBy.map((orderBy) => {
      return `${orderBy.column}:${orderBy.order}`;
    });
  }
  const query = new URLSearchParams(variables).toString();
  const request = await $voixNuxtApi(
    `/api/admin/voix/releases?${query.toString()}`
  );
  setReleasesInStore(request.data.value);
  adminStore.isLoading = false;
  return request;
}
async function getRelease(variables) {
  const adminStore = useAdminStore();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/releases/${variables.id}`
  );
  adminStore.isLoading = false;
  return request;
}
async function updateRelease(variables) {
  const adminStore = useAdminStore();
  const voixToast = useVoixToast();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/releases/${variables.id}`,
    {
      method: "PUT",
      body: variables
    }
  );
  adminStore.isLoading = false;
  if (request.data.value) {
    voixToast.add(`Release Updated`, "msg");
    return request;
  } else {
    throw new Error("Unable to save");
  }
}
async function deleteRelease(variables) {
  const adminStore = useAdminStore();
  const voixToast = useVoixToast();
  adminStore.isLoading = true;
  const request = await $voixNuxtApi(
    `/api/admin/voix/releases/${variables.id}`,
    {
      method: "DELETE"
    }
  );
  adminStore.isLoading = false;
  if (request.data.value) {
    voixToast.add(`Release Deleted`, "msg");
    return request;
  } else {
    throw new Error("Unable to save");
  }
}
export { deleteRelease, getRelease, getReleases, updateRelease };
